"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function Mission() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const principles = [{
    number: "01",
    title: "MISSION",
    description: "To help businesses simplify complex data and processes through practical analytics, reliable reporting, and intelligent automation.\n\n\nWe aim to reduce repetitive work, improve accuracy, strengthen internal control, and give decision-makers information they can trust."
  }, {
    number: "02",
    title: "VISION",
    description: "To become a trusted provider of practical, secure, flexible, and scalable data and automation solutions.\n\n\nWe envision a future where businesses of every size can access clear information, efficient processes, and technology that supports confident growth."
  }, {
    number: "03",
    title: "VALUES",
    description: "Clarity,\naccuracy,\nreliability,\nsecurity,\nconfidentiality, practical innovation, and client focus guide every solution we design and every relationship we build."
  }];
  return <section data-section-id="2627" id="mission-vision" className="text-foreground py-40 px-6 md:px-12 lg:px-16 relative overflow-hidden dark bg-accent">
      {}
      <Separator className="bg-border mb-12" />

      {}
      <div className="mb-20 md:mb-24">
        <span className="font-mono text-[11px] tracking-widest text-primary uppercase">OUR PURPOSE</span>
      </div>

      {}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 relative">
        {}
        <div className="hidden lg:block absolute pointer-events-none" style={{
        left: "calc(41.666% - 12px)",
        top: "40%"
      }} aria-hidden="true">
          <div className="relative w-6 h-6 opacity-30">
            <div className="absolute top-1/2 left-0 w-full h-px bg-primary" />
            <div className="absolute top-0 left-1/2 h-full w-px bg-primary" />
          </div>
        </div>

        {}
        <div ref={headingRef} className={`lg:col-span-5 transition-all duration-1000 ease-out ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default font-bold leading-[0.9] text-foreground" style={{
          fontSize: "clamp(3.5rem, 9vw, 6rem)",
          letterSpacing: "-0.03em"
        }}>
            <span className="block">OUR<br />MISSION<br /></span>
            <span className="block">VISION</span>
            
            <span className="block">VALUES</span>
            
          </h2>
        </div>

        {}
        <div className="lg:col-span-7 lg:pt-20">
          {}
          <div ref={paragraphRef} className={`transition-all duration-1000 ease-out delay-150 ${paragraphVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <p className="font-default leading-snug mb-16 md:mb-20 text-secondary" style={{
            fontSize: "clamp(1.25rem, 2.2vw, 1.625rem)"
          }}>Our mission, vision, and values define why Infinix Solutions exists, where we are going, and the principles that guide every solution we create.</p>
          </div>

          {}
          <div ref={cardsRef} className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {principles.map((principle, i) => <div key={principle.number} data-index={i} className={`group relative p-6 backdrop-blur-sm border border-border hover:border-primary shadow-lg hover:shadow-xl transition-all duration-500 ease-out hover:-translate-y-0.5 ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            backgroundColor: "var(--card)",
            transitionDelay: cardsVisible ? `${i * 120}ms` : "0ms"
          }}>
                {}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-10 transition-opacity duration-500 pointer-events-none" style={{
              boxShadow: "0 0 40px -10px var(--primary)"
            }} aria-hidden="true" />

                <div className="relative z-10">
                  {}
                  <span className="font-mono text-[11px] tracking-widest block mb-8 text-secondary">
                    {principle.number}
                  </span>

                  {}
                  <h3 className="font-default font-bold text-foreground mb-5" style={{
                fontSize: "1.5rem",
                letterSpacing: "-0.02em"
              }}>
                    {principle.title}
                  </h3>

                  {}
                  <Separator className="bg-border mb-5" />

                  {}
                  <p className="font-default leading-relaxed text-muted-foreground !text-lg">
                    {principle.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}